import { render, staticRenderFns } from "./Rechenschaftsberichte.vue?vue&type=template&id=564152b0&scoped=true&"
import script from "./Rechenschaftsberichte.vue?vue&type=script&lang=js&"
export * from "./Rechenschaftsberichte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564152b0",
  null
  
)

export default component.exports